const PEE_DURATION_MIN = 2000;
const PEE_DURATION_MAX = 4000;
const APPROACH_TIMEOUT = 4000;

export const pee = {
  id: 'pee',
  state: 'pee',
  system: false,

  enter(ctx) {
    ctx.movement.stopWalk();
    ctx._peePhase = 'peeing';
    ctx._peeApproachTime = 0;

    const texts = ctx.environment.findTextElements();
    if (texts.length > 0) {
      const target = texts[Math.floor(Math.random() * texts.length)];
      const pos = ctx.movement.getPosition();
      const petSize = ctx.config.size || 48;
      const dist = Math.abs(pos.x - target.x);

      if (dist > petSize) {
        ctx._peePhase = 'approach';
        ctx._peeTargetX = target.x;
        ctx.visualState = 'walk';
        const dir = target.x > pos.x ? 1 : -1;
        ctx.movement.walkTo(dir);
        return;
      }
    }

    ctx.stateTimer = ctx.randomRange(PEE_DURATION_MIN, PEE_DURATION_MAX);
  },

  update(ctx, dt) {
    if (!ctx.movement.isGrounded()) {
      ctx.transition('fall');
      return;
    }

    if (ctx._peePhase === 'approach') {
      ctx._peeApproachTime += dt;
      const pos = ctx.movement.getPosition();
      const arrived = Math.abs(pos.x - ctx._peeTargetX) < 30;
      const timedOut = ctx._peeApproachTime > APPROACH_TIMEOUT;
      const hitEdge = ctx.movement.isAtViewportEdge() || ctx.movement.isAtEdge();

      if (arrived || timedOut || hitEdge) {
        ctx.movement.stopWalk();
        ctx._peePhase = 'peeing';
        ctx.visualState = null;
        ctx.stateTimer = ctx.randomRange(PEE_DURATION_MIN, PEE_DURATION_MAX);
      }
      return;
    }

    ctx.stateTimer -= dt;
    if (ctx.stateTimer <= 0) ctx.transitionToNext();
  },

  exit(ctx) {
    ctx.movement.stopWalk();
    ctx.visualState = null;
    ctx._peePhase = null;
    ctx._peeTargetX = null;
    ctx._peeApproachTime = 0;
  },
};
